function dismissStorageKey(userId) {
  return userId != null && userId !== '' ? `hrm_onboarding_survey_dismissed_${userId}` : null
}

export function getDismissedSurveyType(userId) {
  const key = dismissStorageKey(userId)
  if (!key || typeof sessionStorage === 'undefined') {
    return null
  }
  return sessionStorage.getItem(key)
}

export function setDismissedSurveyType(userId, surveyType) {
  const key = dismissStorageKey(userId)
  if (key && typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(key, surveyType)
  }
}

export function clearDismissedSurveyType(userId) {
  const key = dismissStorageKey(userId)
  if (key && typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(key)
  }
}
